import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, FormControl, InputLabel, Select, MenuItem, Snackbar, Alert, FormControlLabel, Checkbox, TextField } from '@mui/material';
import { useAuth } from '../components/AuthContext';
import { API_BASE_URL } from '../components/api.js';
import ReactDataSheet from 'react-datasheet';
import 'react-datasheet/lib/react-datasheet.css';
import './PontoFechar.css';

function PontoFechar() {
  const { authenticatedFetch } = useAuth();

  // Opções dos selects
  const [anosOptions, setAnosOptions]   = useState([]);
  const [mesesOptions, setMesesOptions] = useState([]);

  // Selecionados
  const [fechar_ano, setAno] = useState('');
  const [fechar_mes, setMes] = useState('');

  // Dados
  const [pontos, setPontos]                   = useState([]);
  const [faltasDetalhadas, setFaltasDetalhadas] = useState({});
  const [grid, setGrid]                       = useState([]);
  const [loading, setLoading]                 = useState(false);
  const [somenteAtivos, setSomenteAtivos]     = useState(true);
  const [selecionados, setSelecionados]       = useState({});
  const [snackbar, setSnackbar]               = useState({ open: false, message: '', severity: 'success' });

  const nomeMes = (n) => [
    'Janeiro','Fevereiro','Março','Abril','Maio','Junho',
    'Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'
  ][n - 1] || n;

  // ── Formatação ────────────────────────────────────────────────────────────
  const minutosParaHMM = (minutos) => {
    const m = Math.abs(Number(minutos) || 0);
    return `${Math.floor(m / 60)},${(m % 60).toString().padStart(2, '0')}`;
  };

  const formatarNumero = (valor, casas = 2) => {
    if (!valor || valor === 0) return '0';
    const num = parseFloat(valor);
    if (isNaN(num) || !isFinite(num)) return '0';
    return num.toFixed(casas).replace('.', ',');
  };

  // ── Formatação de data ISO → DD/MM/AAAA ──────────────────────────────────
  const formatarData = (dataISO) => {
    if (!dataISO) return '';
    const [ano, mes, dia] = dataISO.substring(0, 10).split('-');
    return `${dia}/${mes}/${ano}`;
  };

  // ── Lógica de Seleção ─────────────────────────────────────────────────────
  const toggleLinha = (nome) => {
    setSelecionados(prev => ({
      ...prev,
      [nome]: !prev[nome]
    }));
  };

  const toggleSelecionarTodos = (checked) => {
    const novosSelecionados = {};
    if (checked) {
      pontosFiltrados.forEach(p => {
        novosSelecionados[p.nome_completo] = true;
      });
    }
    setSelecionados(novosSelecionados);
  };

  const convertToGrid = (data) => {
    if (!data || data.length === 0) return [];
    const header = [
      { value: 'Sél.',                             readOnly: true, width: 40  },
      { value: 'Tipo de Cálculo',                  readOnly: true, width: 70  },
      { value: 'Código Folha',                     readOnly: true, width: 70  },
      { value: 'Nome dos Colaboradores',            readOnly: true, width: 280 },
      { value: 'Hora Extra 70%',                   readOnly: true, width: 80  },
      { value: 'Hora Extra (Treinamento/Curso)',    readOnly: true, width: 90  },
      { value: 'Feriado (Dias)',                   readOnly: true, width: 70  },
      { value: 'Reembolso',                        readOnly: true, width: 80  },
      { value: 'Adic. Noturno 40%',               readOnly: true, width: 80  },
      { value: 'Red. Adic. Noturno 40%',           readOnly: true, width: 90  },
      { value: 'Gratif. Espontânea',               readOnly: true, width: 70  },
      { value: 'Faltas (Horas)',                   readOnly: true, width: 80  },
      { value: 'Faltas (Dias)',                    readOnly: true, width: 70  },
      { value: 'DSR Faltas',                       readOnly: true, width: 70  },
      { value: 'Desc. VT',                         readOnly: true, width: 70  },
      { value: 'Vale Transporte (Vlr Recarregado)', readOnly: true, width: 90 },
      { value: 'Desc. Quebra de Caixa',            readOnly: true, width: 80  },
      { value: 'Vales',                            readOnly: true, width: 80  },
      { value: 'Danos Causados',                   readOnly: true, width: 80  },
      { value: 'Suspensão Disciplinar',            readOnly: true, width: 80  },
      { value: 'Auxílio Combustível',              readOnly: true, width: 80  },
    ];
    const rows = data.map(item => [
      {
        value: !!selecionados[item.nome_completo],
        readOnly: true,
        component: (
          <Checkbox
            size="small"
            checked={!!selecionados[item.nome_completo]}
            onChange={() => toggleLinha(item.nome_completo)}
            sx={{ p: 0 }}
          />
        )
      },
      { value: item.tipo_calculo || '11',                          readOnly: true },
      { value: item.codigo_folha || '',                            readOnly: true },
      { value: item.nome_completo || '',                           readOnly: true },
      { value: minutosParaHMM(item.hora_extra_70),                 readOnly: true },
      { value: minutosParaHMM(item.hora_extra_curso),              readOnly: true },
      { value: formatarNumero(item.feriado_dias, 0),               readOnly: true },
      { value: formatarNumero(item.reembolso),                     readOnly: true },
      { value: minutosParaHMM(item.adicional_noturno),             readOnly: true },
      { value: formatarNumero(item.red_adicional_noturno),         readOnly: true },
      { value: formatarNumero(item.gratificacao_espontanea),       readOnly: true },
      { value: minutosParaHMM(item.faltas_horas),                  readOnly: true },
      { value: formatarNumero(item.faltas_dias, 0),                readOnly: true },
      { value: formatarNumero(item.dsr_faltas),                    readOnly: true },
      { value: formatarNumero(item.desc_vt),                       readOnly: true },
      { value: formatarNumero(item.vt_recarregado),                readOnly: true },
      { value: formatarNumero(item.desc_quebra_caixa),             readOnly: true },
      { value: formatarNumero(item.vales),                         readOnly: true },
      { value: formatarNumero(item.danos_causados),                readOnly: true },
      { value: formatarNumero(item.suspensao_disciplinar, 0),      readOnly: true },
      { value: formatarNumero(item.auxilio_combustivel),           readOnly: true },
    ]);
    return [header, ...rows];
  };

  // ── Busca anos disponíveis no banco ──────────────────────────────────────
  const fetchAnos = async () => {
    try {
      const res = await authenticatedFetch(`${API_BASE_URL}/api/ponto-fechar-anos/`);
      if (!res.ok) return;
      const data = await res.json();
      setAnosOptions(data);

      if (data.length > 0) {
        const maisRecente = data[0];
        setAno(maisRecente);
        fetchMeses(maisRecente);
      }
    } catch (err) {
      console.error('Erro ao buscar anos:', err);
    }
  };

  // ── Busca meses disponíveis para o ano selecionado ───────────────────────
  const fetchMeses = async (anoSelecionado) => {
    try {
      const res = await authenticatedFetch(
        `${API_BASE_URL}/api/ponto-fechar-meses/?ano=${anoSelecionado}`
      );
      if (!res.ok) return;
      const data = await res.json();
      setMesesOptions(data);

      if (data.length > 0) {
        const maisRecente = data[0];
        setMes(maisRecente);
        fetchPontos(anoSelecionado, maisRecente);
      }
    } catch (err) {
      console.error('Erro ao buscar meses:', err);
    }
  };

  // ── Busca dados da tabela + faltas detalhadas em paralelo ─────────────────
  const fetchPontos = async (anoParam, mesParam) => {
    setLoading(true);
    try {
      const [resPontos, resFaltas] = await Promise.all([
        authenticatedFetch(`${API_BASE_URL}/api/ponto-fechar/?mes=${mesParam}&ano=${anoParam}`),
        authenticatedFetch(`${API_BASE_URL}/api/ponto-fechar-faltas-detalhadas/?mes=${mesParam}&ano=${anoParam}`),
      ]);

      if (!resPontos.ok) throw new Error('Erro ao buscar pontos');

      const dataPontos = await resPontos.json();
      const dataFaltas = resFaltas.ok ? await resFaltas.json() : {};

      const listaOriginal = dataPontos.dados_tabela || [];
      setPontos(listaOriginal);
      setFaltasDetalhadas(dataFaltas);

      // Inicializar selecionados com ativos
      const inicializarSelecionados = {};
      listaOriginal.forEach(p => {
        if (p.ativo !== false) inicializarSelecionados[p.nome_completo] = true;
      });
      setSelecionados(inicializarSelecionados);

    } catch (err) {
      console.error(err);
      setSnackbar({ open: true, message: 'Erro ao buscar pontos', severity: 'error' });
      setPontos([]);
      setFaltasDetalhadas({});
    }
    setLoading(false);
  };

  // ── Handlers de filtro ────────────────────────────────────────────────────
  const handleAnoChange = (novoAno) => {
    setAno(novoAno);
    setMes('');
    setMesesOptions([]);
    setPontos([]);
    setFaltasDetalhadas({});
    fetchMeses(novoAno);
  };

  const handleMesChange = (novoMes) => {
    setMes(novoMes);
    fetchPontos(fechar_ano, novoMes);
  };

  // ── Filtragem local por ativo ─────────────────────────────────────────────
  const pontosFiltrados = somenteAtivos
    ? pontos.filter(p => p.ativo !== false)
    : pontos;

  const gridFiltrado = convertToGrid(pontosFiltrados);

  // ── Copiar para Excel ─────────────────────────────────────────────────────
  const handleCopyDadosExcel = () => {
    const dadosParaCopiar = pontosFiltrados.filter(p => selecionados[p.nome_completo]);

    if (dadosParaCopiar.length === 0) {
      setSnackbar({ open: true, message: 'Nenhum colaborador selecionado.', severity: 'warning' });
      return;
    }
    const linhas = dadosParaCopiar.map(item => [
      minutosParaHMM(item.hora_extra_70),
      minutosParaHMM(item.hora_extra_curso),
      formatarNumero(item.feriado_dias, 0),
      formatarNumero(item.reembolso),
      minutosParaHMM(item.adicional_noturno),
      formatarNumero(item.red_adicional_noturno),
      formatarNumero(item.gratificacao_espontanea),
      minutosParaHMM(item.faltas_horas),
      formatarNumero(item.faltas_dias, 0),
      formatarNumero(item.dsr_faltas),
      formatarNumero(item.desc_vt),
      formatarNumero(item.vt_recarregado),
      formatarNumero(item.desc_quebra_caixa),
      formatarNumero(item.vales),
      formatarNumero(item.danos_causados),
      formatarNumero(item.suspensao_disciplinar, 0),
      formatarNumero(item.auxilio_combustivel),
    ].join('\t')).join('\n');

    navigator.clipboard.writeText(linhas)
      .then(() => setSnackbar({
        open: true,
        message: `✓ ${dadosParaCopiar.length} colaborador(es) copiado(s)!`,
        severity: 'success'
      }))
      .catch(() => setSnackbar({ open: true, message: 'Erro ao copiar.', severity: 'error' }));
  };

  const handleCopyDadosExcelComHeader = () => {
    const marcados = pontosFiltrados.filter(p => selecionados[p.nome_completo]);

    if (marcados.length === 0) {
      setSnackbar({ open: true, message: 'Selecione ao menos um colaborador.', severity: 'warning' });
      return;
    }

    const header = [
      "Tipo de Cálculo", "Código Folha", "Nome dos Colaboradores",
      "Hora Extra 70%", "Hora Extra Curso", "Feriado Dias", "Reembolso",
      "Adic Noturno", "Red Adic Noturno", "Gratif Espontanea", "Faltas Horas",
      "Faltas Dias", "DSR Faltas", "Desc VT", "VT Recarregado",
      "Quebra Caixa", "Vales", "Danos", "Suspensao", "Aux Combustivel"
    ].join('\t');

    const linhas = marcados.map(item => [
      item.tipo_calculo || '11',
      item.codigo_folha || '',
      item.nome_completo || '',
      minutosParaHMM(item.hora_extra_70),
      minutosParaHMM(item.hora_extra_curso),
      formatarNumero(item.feriado_dias, 0),
      formatarNumero(item.reembolso),
      minutosParaHMM(item.adicional_noturno),
      formatarNumero(item.red_adicional_noturno),
      formatarNumero(item.gratificacao_espontanea),
      minutosParaHMM(item.faltas_horas),
      formatarNumero(item.faltas_dias, 0),
      formatarNumero(item.dsr_faltas),
      formatarNumero(item.desc_vt),
      formatarNumero(item.vt_recarregado),
      formatarNumero(item.desc_quebra_caixa),
      formatarNumero(item.vales),
      formatarNumero(item.danos_causados),
      formatarNumero(item.suspensao_disciplinar, 0),
      formatarNumero(item.auxilio_combustivel),
    ].join('\t')).join('\n');

    navigator.clipboard.writeText(header + '\n' + linhas)
      .then(() => setSnackbar({
        open: true,
        message: `✓ Tabela completa copiada com cabeçalho!`,
        severity: 'success'
      }))
      .catch(() => setSnackbar({ open: true, message: 'Erro ao copiar.', severity: 'error' }));
  };

  // ── Lógica do Resumo Texto ────────────────────────────────────────────────
  const gerarResumoTexto = () => {
    const marcados = pontosFiltrados.filter(p => selecionados[p.nome_completo]);
    if (marcados.length === 0) return "Nenhum colaborador selecionado para o resumo.";

    return marcados.map(p => {
      const primeiroNome = p.nome_completo ? p.nome_completo.split(' ')[0] : 'Colaborador';

      // ── Faltas detalhadas ───────────────────────────────────────────────
      const faltasList = faltasDetalhadas[p.nome_completo] || [];
      const totalFaltas = faltasList.length;
      const faltasInjustificadas = faltasList.filter(f =>
        f.tipo.toLowerCase().includes('injustificad')
      ).length;

      const faltasTexto = faltasList.length > 0
        ? faltasList.map(f => `    • ${f.tipo}: ${formatarData(f.data)}`).join('\n')
        : '    Nenhuma falta registrada';

      // ── Quebra de Caixa (Montando o bloco de texto detalhado) ───────────
      const quebraCaixa = parseFloat(p.desc_quebra_caixa) || 0;
      const detalhesQuebras = p.detalhe_quebras_datas || [];
      
      let quebraTexto = 'Sem quebra';
      if (quebraCaixa > 0) {
        quebraTexto = `R$ ${formatarNumero(quebraCaixa)}`;
        if (detalhesQuebras.length > 0) {
          quebraTexto += `\n    Ocorrências (< -2.00): [ ${detalhesQuebras.join(' | ')} ]`;
        }
      }

      // ── Vale Transporte ─────────────────────────────────────────────────
      const vtDesc        = parseFloat(p.desc_vt) || 0;
      const vtRecarregado = parseFloat(p.vt_recarregado) || 0;

      return (
        `Nome: ${primeiroNome}\n` +
        `Nome Completo: ${p.nome_completo}\n` +
        `Hora extra: ${p.hora_extra_70} min (${minutosParaHMM(p.hora_extra_70).replace(',', ':')})\n` +
        `Hora em falta: ${p.faltas_horas} min (${minutosParaHMM(p.faltas_horas).replace(',', ':')})\n` +
        `Hora noturna: ${p.adicional_noturno} min (${minutosParaHMM(p.adicional_noturno).replace(',', ':')})\n` +
        `Faltas: ${totalFaltas} dia(s)${faltasInjustificadas > 0 ? ` (${faltasInjustificadas} injustificada(s))` : ''}\n` +
        faltasTexto + '\n' +
        `Quebra de Caixa: ${quebraTexto}\n` +
        `Vale Transporte: R$ ${formatarNumero(vtRecarregado)}`
      );
    }).join('\n\n' + '─'.repeat(40) + '\n\n');
  };

  // ── Carga inicial ─────────────────────────────────────────────────────────
  useEffect(() => { fetchAnos(); }, []);

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>Fechar Ponto</Typography>

      {/* Filtros */}
      <Box sx={{ display: 'flex', gap: 2, mb: 3, alignItems: 'center', flexWrap: 'wrap' }}>
        <FormControl sx={{ minWidth: 110 }}>
          <InputLabel>Ano</InputLabel>
          <Select value={fechar_ano} label="Ano" onChange={e => handleAnoChange(e.target.value)}>
            {anosOptions.map(a => (
              <MenuItem key={a} value={a}>{a}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ minWidth: 160 }} disabled={!fechar_ano || mesesOptions.length === 0}>
          <InputLabel>Mês</InputLabel>
          <Select value={fechar_mes} label="Mês" onChange={e => handleMesChange(e.target.value)}>
            {mesesOptions.map(m => (
              <MenuItem key={m} value={m}>
                {String(m).padStart(2,'0')} — {nomeMes(m)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControlLabel
          control={
            <Checkbox
              checked={somenteAtivos}
              onChange={e => setSomenteAtivos(e.target.checked)}
            />
          }
          label="Somente ativos"
        />

        <FormControlLabel
          control={
            <Checkbox
              indeterminate={
                Object.values(selecionados).filter(v => v).length > 0 &&
                Object.values(selecionados).filter(v => v).length < pontosFiltrados.length
              }
              checked={
                pontosFiltrados.length > 0 &&
                Object.values(selecionados).filter(v => v).length === pontosFiltrados.length
              }
              onChange={e => toggleSelecionarTodos(e.target.checked)}
            />
          }
          label="Selecionados"
        />

        <Button
          variant="contained"
          color="info"
          onClick={handleCopyDadosExcel}
          disabled={!pontos || pontos.length === 0}
          sx={{ fontWeight: 'bold' }}
        >
          📋 Copiar Dados para Excel
        </Button>

        <Button
          variant="contained"
          color="success"
          onClick={handleCopyDadosExcelComHeader}
          disabled={pontosFiltrados.length === 0}
          sx={{ fontWeight: 'bold' }}
        >
          📊 Copiar com Cabeçalho
        </Button>
      </Box>

      {loading && <Typography color="text.secondary">Carregando...</Typography>}

      {pontos.length > 0 && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {pontosFiltrados.length} colaborador(es) exibido(s) — {nomeMes(fechar_mes)}/{fechar_ano}
        </Typography>
      )}

      {/* Tabela */}
      <Box sx={{ width: '100%', maxWidth: 1200, overflowX: 'auto', border: '1px solid #ddd', mb: 3 }}>
        {gridFiltrado.length > 0 ? (
          <div className="tabela-ponto-fechar">
            <ReactDataSheet
              data={gridFiltrado}
              valueRenderer={(cell) => cell.component ? cell.component : cell.value}
              onCellsChanged={() => {}}
              sheetRenderer={(props) => {
                const totalWidth = gridFiltrado[0]?.reduce((sum, cell) => sum + (cell.width || 100), 0) || 0;
                return (
                  <table className={props.className + ' data-grid-container'} style={{ width: totalWidth }}>
                    <colgroup>
                      {gridFiltrado[0]?.map((cell, i) => <col key={i} style={{ width: cell.width || 100 }} />)}
                    </colgroup>
                    <thead>
                      <tr>{gridFiltrado[0]?.map((cell, i) => <td key={i}>{cell.value}</td>)}</tr>
                    </thead>
                    <tbody>{props.children.slice(1)}</tbody>
                  </table>
                );
              }}
            />
          </div>
        ) : (
          !loading && (
            <Box sx={{ p: 4, textAlign: 'center' }}>
              <Typography color="text.secondary">
                Selecione o ano e mês para visualizar os dados.
              </Typography>
            </Box>
          )
        )}
      </Box>

      {/* Resumo em Texto */}
      {pontosFiltrados.length > 0 && (
        <Box sx={{ maxWidth: 1200, mt: 2 }}>
          <TextField
            multiline
            fullWidth
            minRows={10}
            variant="outlined"
            value={gerarResumoTexto()}
            InputProps={{ readOnly: true }}
            sx={{
              backgroundColor: '#f9f9f9',
              '& .MuiInputBase-input': {
                fontFamily: 'monospace',
                fontSize: '14px',
                lineHeight: '1.2'
              }
            }}
          />
        </Box>
      )}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
      >
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
}

export default PontoFechar;